import { ApplicationRoutes } from '../../../app-routes-names'

export const TargetsRoutes = {
  objectives: 'objectives',
  objectivesWithWeekNumber: 'objectives/:weekNumber',
  objectivesVsComp: 'objectives-vs-comp',
  rankings: 'rankings',
  periodRankings: 'period-rankings',
  history: 'history',
  weeklyAverage: 'weekly-average',
  yearlyTargets: 'yearly-targets',
  yearlyTargetsDetail: 'yearly-targets/:locationId/:year'
}

const { targets } = ApplicationRoutes

export const TargetsPaths = {
  objectives: `/${targets}/${TargetsRoutes.objectives}`,
  objectivesWithWeekNumber: (weekNumber: number) =>
    `/${targets}/${TargetsRoutes.objectives}/${weekNumber}`,
  objectivesVsComp: `/${targets}/${TargetsRoutes.objectivesVsComp}`,
  rankings: `/${targets}/${TargetsRoutes.rankings}`,
  periodRankings: `/${targets}/${TargetsRoutes.periodRankings}`,
  history: `/${targets}/${TargetsRoutes.history}`,
  weeklyAverage: `/${targets}/${TargetsRoutes.weeklyAverage}`,
  yearlyTargets: `/${targets}/${TargetsRoutes.yearlyTargets}`,
  yearlyTargetsDetail: (locationId: string, year: number) =>
    `/${targets}/yearly-targets/${locationId}/${year}`
}
